var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f2g-tooltip"},[_c('v-tooltip',{attrs:{"right":_vm.right,"left":_vm.left,"top":_vm.top,"bottom":_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm.text))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }